var styles = {"clearLinkStyles":"LinkButton-module_clearLinkStyles__ZWj43","disabled":"LinkButton-module_disabled__8ZB7h"};

export { styles as default };
//# sourceMappingURL=LinkButton.module.css.js.map
